export enum ContractDocumentType {
    AGREEMENT = "Agreement",
    LICENSE = "License",
}